import { render, staticRenderFns } from "./PopUpTemplate.vue?vue&type=template&id=29cb0569&"
import script from "./PopUpTemplate.vue?vue&type=script&lang=js&"
export * from "./PopUpTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports